<template>
<v-layout row full-height>
  <v-flex>
    <v-card>
      <v-card-text class="stats">
        <span class="display-1">{{ stats.pages }}</span>
        <br>
        <span class="body-2 grey--text">Pages</span>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex>
    <v-card>
      <v-card-text class="stats">
        <span class="display-1">{{ stats.journals }}</span>
        <br>
        <span class="body-2 grey--text">Journals</span>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex>
    <v-card>
      <v-card-text class="stats">
        <span class="display-1">{{ stats.medias }}</span>
        <br>
        <span class="body-2 grey--text">Medias</span>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  name: 'search-stats',

  props: [
    'stats'
  ],
};
</script>

<style scoped>
.stats {
  margin-left: 8px;
}
</style>